<template>
    <!--
        作者：kmdshop
        时间：2020-06-01
        描述：插件中心-现有库存-修改
      -->
      <el-dialog
      title="管理城市"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="70%"
    >
  
    <div class="product-add pb50">
  
            <el-form size="small" :model="form" ref="form"  label-width="100px">
             <div>
        
                <el-tree
                v-loading="cloading"
                element-loading-text="拼命加载中"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                empty-text=""
                :data="province_list"
                node-key="id"
                default-expand-all
                @node-drop="handleDrop"
                @node-click="handleClick"
                draggable
                :expand-on-click-node="false"
                :filter-node-method="filterNode"
                ref="tree"
                >
                <span class="custom-tree-node"  style=" width: 100%; " slot-scope="{ node, data }">
                    <span class="m30">{{ data.name }}</span>

               
                    <el-switch style="margin-left: 20px;" :key="data.id"  v-model="data.status" 
                    :active-value="1"
                    :inactive-value="0"
                    @change="isDefaultChange(data.id,data.level,data.status)"></el-switch>
                    
                    <div style="clear: both;"></div>
                </span>
                </el-tree>
        </div>

  

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <!-- <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button> -->
        </div>
      </el-form>
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
      </Upload>
  
    </div>
  </el-dialog>
    
  </template>
  
  <script>

import AuthUserApi from '@/api/authuser.js';
  import CityApi from '@/api/citys.js';

  export default {
    components: {
       /*图片上传*/
   
    },
    data() {
      return {
      
        /*form表单数据*/
        form: {

        },
        loading: false,
        dialogVisible:false,
        isProductUpload:false,
        code:"album",
        cloading:false,
        province_list: [],
        params:{
            id: 0,
            type: 0,
          },
          open_cadd:false,
          flag:false,
          type:"pc"
      };
    },
    created() {
      this.dialogVisible = this.open_add;
      this.getDetail();
      this.getParams()
    },
    props: ["open_add","shop_user_id"],
    methods: {
      handleDrop(draggingNode, dropNode, dropType, ev) {
          console.log("tree drop: ", dropNode.label);
        },
        isDefaultChange(id,level,status){
          var self = this;
          let params = {
            id:id,
            level:level,
            status:status?1:0,
            shop_user_id:self.shop_user_id,
          }
          this.flag = false;
          CityApi.open(params, true).then(res => {
              console.log(res)
              if(res.msg == "开启成功"){
                  self.$message({
                  message:"设置成功",
                  type: 'success',
                });
                self.flag = true;
                setTimeout(function(){
                    self.handleClick({
                    id:id,
                    type:level,
                    level:level,
                    end:0
                  })
                },500)
                
              }else{
                self.flag = true;
                  self.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
              self.loading=false;
            })
            .catch(error => {
              self.loading=false;
            });
  
         
  
        },  
  
     // 点击
     handleClick(e){
      console.log('-------',this.flag)
      this.params.id = e.id;
            this.params.type = e.level;
   
            if(e.level>0){
              return false;
            }
            console.log('e',e)
            if (!e.children && e.end==0){
  
              this.getParams(e);
            }
      
        },
            /*获取配置数据*/
            getParams(node) {
              let self = this;
              let params = self.params;
              params.shop_user_id=self.shop_user_id;
              CityApi.getTree(params, true).then(res => {
                  self.data_setting = res.data.data_setting
                  if (self.params.id>0 && self.params.type>0){
      
                    self.append(node, res.data.list);
                    self.flag = true;
                    self.$forceUpdate()
                  } else {
                    self.province_list = res.data.list;
                  }  
                  self.loading=false;
                })
                .catch(error => {
                  self.loading=false;
                });
        },
  
        filterNode(value, data) {
          if (!value) return true;
          return data.label.indexOf(value) !== -1;
        },
  
           /*关闭弹窗*/
           closeProductDialogFunc(e) {
              this.open_cadd = e.openDialog;
  
        },

  
     // 增加
     append(data, children_data) {
          if (!children_data.length) data.end = 1;
          children_data.forEach(e => {
            if (!data.children) {
              this.$delete(data, 'children')
              this.$set(data, "children", []);
            }
            data.children.push(e);
          });
          this.$forceUpdate();
        },
  
        remove(node, data) {
          const parent = node.parent;
          const children = parent.data.children || parent.data;
          const index = children.findIndex((d) => d.id === data.id);
          children.splice(index, 1);
        },
        renderContent(h, { node, data, store }) {
          return (
            <span class="custom-tree-node">
              <span>{node.label}</span>
              <span>
                <el-button
                  size="mini"
                  type="text"
                  on-click={() => this.append(data)}
                >
                  Append
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  on-click={() => this.remove(node, data)}
                >
                  Delete
                </el-button>
              </span>
            </span>
          );
        },
        handleDrop(draggingNode, dropNode, dropType, ev) {
          console.log("tree drop: ", dropNode.label);
        },
  
  
  
  
  
      
    
       /*关闭弹窗*/
       dialogFormVisible(result) {
        this.$emit("close", {});
      },
      cancelFunc(){//取消
        this.dialogFormVisible("error")
      },
      getDetail() {
        let self = this;
        // 取到路由带过来的参数
        AuthUserApi.userEditInfo({    
            
            shop_user_id: self.shop_user_id,
            type:self.type
        },true).then(res => {

          self.form = res.data;
            self.loading = false;
  
        
          })
          .catch(error => {});
      },
      onSubmit() {
        let self = this;
        let form = self.form;
   
        self.$refs.form.validate(valid => {
          if (valid) {
            self.loading = true;
            form.alone_grade_equity = self.convertJson(self.form.gradeList, form.is_alone_grade);
            Existing_inventoryApi.edit(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.dialogFormVisible("error")
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
        /*转JSON字符串*/
        convertJson(list, type) {
        let obj = {};
        if (type == 2) {
          list.forEach(item => {
            obj[item.grade_id] = item.product_fixed;
          });
        } else if (type == 1) {
          list.forEach(item => {
            obj[item.grade_id] = item.product_equity;
          });
        } else if (type == 20) {
          list.forEach(item => {
            obj[item.grade_id] = item.independent_commission;
          });
        }else if(type == 30){
          list.forEach(item => {
            if(item.product_lateral_ratio){
              obj[item.grade_id] = item.product_lateral_ratio;
            }else{
              obj[item.grade_id] = 0;
            }
          
          });
         
        }
        return JSON.stringify(obj);
      },
  
  

      openProductUpload: function (code) {
        this.isProductUpload = true;
        this.code = code
      },
  
    
      /*上传商品图片*/
      returnProductImgsFunc(e) {
        if(this.code == 'album'){
          if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });
  
          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }
  
          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
        }else{
          if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });
  
          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }
  
          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
        }
        
        this.isProductUpload = false;
      },
  
      /*删除商品图片*/
      deleteImg(index,code) {
        if(code == 'album'){
          this.form.image.splice(index, 1);
        }else if(code == 'bannar'){
          this.form.bannar.splice(index, 1);
        }
        
      },
    }
  };
  </script>
  
  <style>
  .edit_container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  
  .ql-editor {
    height: 400px;
  }
  
  
  
  .draggable-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
  
  .draggable-list .wrapper > span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  
  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }
  
  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }
  
  .draggable-list .item:hover .delete-btn {
    display: block;
  }
  
  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }
  
  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }
  
  .draggable-list .img-select i {
    color: #409eff;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/auth_app/user/dialog/city.vue